'use client'

import type React from 'react'
import { useRouter } from 'next/navigation'
import { toast } from 'sonner'
import {
  getBottomCredits,
  setCookieCartId,
  type BottomCredits,
} from '@/lib/actions'
import {
  useApp,
  useCart,
  useCheckout,
  useModals,
  usePagePath,
  useUser,
} from '@/lib/hooks'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { SelectNewOrderOptions } from '@/components/forms/select-new-order-options'

interface SelectNewOrderOptionsModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const SelectNewOrderOptionsModal = ({
  open,
}: SelectNewOrderOptionsModalProps) => {
  const { closeModal } = useModals()

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          closeModal('SELECT_NEW_ORDER_OPTIONS')
        }
      }}
    >
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('SELECT_NEW_ORDER_OPTIONS')}
        size="lg"
        className="bg-gray-50 lg:max-w-[900px]"
      >
        <DialogHeader>
          <DialogTitle>Select New Order Options</DialogTitle>
          <DialogDescription>
            Select the options for your new order
          </DialogDescription>
        </DialogHeader>

        {open && <SelectNewOrderOptions />}
      </DialogContent>
    </Dialog>
  )
}
